import { isNotificationUnread } from "./format-notification-display.js";

/**
 * Notificação pendente que ainda exige decisão (aprovar/recusar).
 * @param {Object} [notification]
 * @returns {boolean}
 */
export function canHaveNotificationActions(notification) {
  return (
    isNotificationUnread(notification) && Boolean(notification?.requiresAction)
  );
}
